export default (axios, path = '/game/owner') => ({
  create: async (game) => {
    return await axios.post(`${path}`, game.jsonData)
  },
  findAllActiveGamesForOwner: async () => {
    return await axios.get(`${path}/own`)
  },
  findAllArchivedGamesForOwner: async () => {
    return await axios.get(`${path}/own/archived`)
  },
  findAllNotActiveGamesForOwner: async () => {
    return await axios.get(`${path}/own?active=false`)
  },
  endGameManually: async (gameId) => {
    return await axios.put(`${path}/${gameId}/end`)
  },
  startGame: async (gameId) => {
    return await axios.put(`${path}/${gameId}/start`)
  },
  endTurnManually: async (gameId) => {
    return await axios.put(`${path}/${gameId}/turn/end`)
  },
  postponeTurn: async ({gameId, seconds}) => {
    return await axios.put(`${path}/${gameId}/turn/postpone?seconds=${seconds}`)
  },
  startTurnManually: async (gameId) => {
    return await axios.put(`${path}/turn/start`, {gameId})
  },
  updateInGame: async ({game, id}) => {
    return await axios.post(`${path}/${id}`, game)
  },
  activateGame: async (id) => {
    return await axios.put(`${path}/${id}`)
  },
  delete: async (id) => {
    return await axios.delete(`${path}/${id}`)
  },
  regenerateAccessCode: async (id) => {
    return await axios.put(`${path}/access-code`, {id})
  },
  downloadGameOverview : async (gameId) => {
    return await axios.get(`${path}/${gameId}/overview`, {
      responseType: 'blob',
    })
  },
  findAllTeamTransactionsByTeamId: async (teamId) => {
    return await axios.get(`${path}/transaction/team/${teamId}`)
  },
  addPlayerToGame: async (user, team) => {
    return await axios.put(`${path}/add-user/`+ user+`/`+ team)
  },
})
